import React from 'react';
import Tool, {
  type ToolArgs,
  type ToolArgsWithController,
} from '../../../tools/Tool';
import tools from '../../../tools';
import { ReactEditor } from 'slate-react';
import { Transforms, type Element } from 'slate';
import toolbarStyles from '../../../components/Toolbar/Toolbar.module.css';
import { LANGUAGES } from '../../../util/prismLanguages';
import { isCodeBlockElement } from '../../../types/guards';

class ToolChooseCodeLanguage extends Tool {
  static toolName = 'Syntax highlighting';

  static elementLanguage(element?: Element): string {
    const raw =
      element && isCodeBlockElement(element) ? element.code_language : '';
    if (Object.hasOwn(LANGUAGES, raw)) {
      return raw;
    } else {
      return '';
    }
  }

  static elementLanguageName(element?: Element): string {
    return LANGUAGES[this.elementLanguage(element)];
  }

  static action({ editor, element, language }: ToolArgs): void {
    if (!editor || !element) return;

    const path = ReactEditor.findPath(editor, element);
    Transforms.setNodes(
      editor,
      {
        code_language: language,
      },
      {
        at: path,
      }
    );
  }

  static renderToolbarComponent({
    editor,
    element,
    controller,
  }: ToolArgsWithController): JSX.Element {
    return (
      <aha-menu>
        <div className={toolbarStyles.toolbarItem} slot="control">
          {this.elementLanguageName(element)}
        </div>
        <aha-menu-content>
          {Object.entries(LANGUAGES).map(([languageCode, languageName]) => (
            <aha-menu-item key={`language-${languageCode}`}>
              <a
                onClick={(event) =>
                  tools.fireToolAction(this, event, {
                    editor,
                    element,
                    language: languageCode,
                    controller,
                  })
                }
              >
                {languageName}
              </a>
            </aha-menu-item>
          ))}
        </aha-menu-content>
      </aha-menu>
    );
  }
}

export default ToolChooseCodeLanguage;
